<template>
  <div>
    <Editor
      :init="initializeTinymceInlineEditor()"
      :initialValue="html"
    />
    <button-dialog :showButtonDialog="showButtonDialog" @insert-html="insertHtml"  @close-button-dialog="closeButtonDialog" />
    <CellImageItem
      :imageUploaderSelector="showImageDialog"
      @set-html-table-img="setHtmlTableImg"
      @close-image-dialog="closeImageDialog"
    />
  </div>
</template>

<script>
import ButtonDialog from './buttonDialog'
import CellImageItem from './CellImageItem'

export default {
  name: 'CellEditor',
  components: { CellImageItem, ButtonDialog },
  props: {
    html: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      editor: null,
      showImageDialog: false,
      showButtonDialog: false
    }
  },
  methods: {
    setHtmlTableImg (img) {
      tinymce.activeEditor.execCommand('mceInsertContent', false, img)
      this.$emit('blur')
    },
    closeImageDialog () {
      this.showImageDialog = false
      this.$emit('blur')
    },
    initializeTinymceInlineEditor () {
      const obj = this
      const htmlTableCellConfig = {
        language: 'ja',
        menubar: false,
        inline: true,
        plugins: ['code', 'link'],
        toolbar_location: 'top',
        toolbar: [
          'alignleft aligncenter alignright | code image button',
          'fontsize forecolor backcolor underline bold strikethrough italic link'
        ],
        setup: function (editor) {
          editor.ui.registry.addButton('image', {
            icon: 'image',
            tooltip: '画像の挿入',
            onAction: function () {
              editor.off('blur')
              obj.showImageDialog = true
            }
          })
          editor.ui.registry.addButton('button', {
            text: 'ボタン',
            tooltip: 'ボタンの挿入',
            onAction: function () {
              editor.off('blur')
              obj.showButtonDialog = true
            }
          })
          editor.on('init', function () {
            if (this.focus) editor.focus()
          })
          editor.on('NodeChange', function () {
            obj.$emit('change', editor.getContent())
          })
          editor.on('focus', function () {
            obj.$emit('focus')
          })
          editor.on('blur', function () {
            obj.$emit('blur')
          })
        }
      }

      /* eslint no-undef: 0 */
      return htmlTableCellConfig
    },
    insertHtml (button) {
      tinymce.activeEditor.execCommand('mceInsertContent', false, this.btnHtml(button))
      tinymce.activeEditor.execCommand('InsertText', false, ' ')
      this.$emit('blur')
      this.closeButtonDialog()
    },
    closeButtonDialog () {
      this.showButtonDialog = false
      this.$emit('blur')
    },
    btnHtml (button) {
      if (button.sizeType === 'auto_adjustment') {
        return `<p class='btn' style='height: auto; padding: 3px 0px;'>
                  <span style="display: inline-block" contenteditable="false">
                    ${this.btnLayout(button)}
                  </span>
                </p>`
      } else if (button.sizeType === 'btn_big') {
        return `<p class='btn' style='height: auto; padding: 3px 0px;'>
                  <span style="display: inline-block;" contenteditable="false">
                    ${this.btnLayout(button)}
                  </span>
                </p>`
      } else if (button.sizeType === 'btn_x_big') {
        return `<p class='btn' style='height: auto; padding: 3px 0px;'>
                  <span style="display: inline-block;" contenteditable="false">
                    ${this.btnLayout(button)}
                  </span>
                </p>`
      }
    },
    btnLayout (button) {
      return `<a
                href="${button.url}"
                style="
                  text-decoration: none;
                  display: block;
                  width: 100%;
                  position: relative;
                  font-weight: bold;
                  color: ${button.fontColor};
                  border-top: ${this.borderTopStyle(button)};
                  border-right: ${this.borderRightStyle(button)};
                  border-bottom: ${this.borderBottomStyle(button)};
                  border-left: ${this.borderLeftStyle(button)};
                  box-shadow: ${this.boxShadowStyle(button)};
                  background: ${this.gradationStyle(button)};
                  border-radius: ${this.borderRadiusStyle(button)};
                "
                target="_blank" rel="noopener noreferrer"
                >
                ${this.buttonLabel(button)}
                <span style="
                  display: flex;
                  justify-content: space-between;
                  padding: 9px 6px;
                  font-size: 12px;
                  flex-direction: row;
                  font-size: ${button.fontSize}px;
                  flex-direction: ${this.flexColumnStyle(button)};
                  width: ${this.btnWidth(button)};
                ">
                  <span class="squareContent" style="${button.type === 'square' ? this.squareBtnStyle() : ''}"> </span>
                  <span class="beforeIcon" style="display: block; align-self: center;">
                    <span class="${button.beforeIcon}" style="color: ${button.fontColor}; display: block;"> </span>
                  </span>
                  <span class="buttonCotent" style="display: block; margin: auto; align-self: center; padding: ${this.paddingStyle(button)}">
                    <span style="color: ${button.fontColor}; word-break: break-all; white-space: pre-wrap">${button.content}</span>
                  </span>
                  <span class="afterIcon" style="display: block; align-self: center;">
                    <span class="${button.afterIcon}" style="color: ${button.fontColor}; display: block;"> </span>
                  </span>
                </span>
              </a>`
    },
    squareBtnStyle () {
      return `display: block;
              content: '';
              padding-top: 95%;`
    },
    btnWidth (button) {
      if (button.sizeType === 'auto_adjustment') {
        return ''
      } else if (button.sizeType === 'btn_big') {
        return button.type === 'rectangle' ? '160px' : '100px'
      } else if (button.sizeType === 'btn_x_big') {
        return button.type === 'rectangle' ? '250px' : '150px'
      }
    },
    borderTopStyle (button) {
      if (button.border && button.border.top) {
        return `${button.border.top.size}px solid ${button.border.top.color}`
      }
      return ''
    },
    borderRightStyle (button) {
      if (button.border && button.border.right) {
        return `${button.border.right.size}px solid ${button.border.right.color}`
      }
      return ''
    },
    borderLeftStyle (button) {
      if (button.border && button.border.left) {
        return `${button.border.left.size}px solid ${button.border.left.color}`
      }
      return ''
    },
    borderBottomStyle (button) {
      if (button.border && button.border.bottom) {
        return `${button.border.bottom.size}px solid ${button.border.bottom.color}`
      }
      return ''
    },
    boxShadowStyle (button) {
      if (button.boxShadow) {
        return `${button.boxShadow.x}px ${button.boxShadow.y}px ${button.boxShadow.blur}px ${button.boxShadow.spread}px rgba(0,0,0,.3)`
      }
      return ''
    },
    paddingStyle (button) {
      if (button.padding) {
        return `${button.padding.y || 0}px ${button.padding.x || 0}px`
      }
      return '0 0'
    },
    borderRadiusStyle (button) {
      if (button.radius) {
        return button.radius
      }
      return '0'
    },
    flexColumnStyle (button) {
      if (button.flexColumn) {
        return 'column'
      }
      return 'row'
    },
    gradationStyle (button) {
      if (button.gradientColor) {
        return `linear-gradient(to bottom, ${button.backgroundColor} 0%, ${button.gradientColor} 100%)`
      }
      return button.backgroundColor
    },
    buttonLabel (button) {
      if (button.labelType === 'top_left_quadrangle') {
        return `<span style='
                  display: block;
                  position: absolute;
                  transform: rotate(-14deg);
                  top: -9px;
                  left: -6px;
                  z-index: 1;
                  white-space: nowrap;
                '>
                  <span style='
                    font-size: 8px;
                    padding: 3px 5px;
                    color: ${button.backgroundColor};
                    background-color: ${button.fontColor};
                    border: 2px solid ${button.backgroundColor};
                  '>
                    ${button.labelText}
                  </span>
                </span>`
      } else if (button.labelType === 'quadrangle') {
        return `<span style="display: block; margin: 8px;">
                  <span style="
                    top: -16px;
                    right: 8px;
                    left: 8px;
                    margin: auto -30px;
                    position: absolute;
                    z-index: 1;
                    transform: scale(0.7);
                  ">
                    <span style="
                      color: ${button.backgroundColor};
                      background-color: ${button.fontColor};
                      border: 2px solid ${button.backgroundColor};
                      display: inline-block;
                      border-radius: 3px;
                      -webkit-box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
                      box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
                      padding: 4px 8px 3px;
                      font-size: 8px;
                      letter-spacing: 2px;
                      align-self: center;
                    ">
                      ${button.labelText}
                    </span>
                  </span>
                </span>`
      } else if (button.labelType === 'speech_bubble') {
        return `<span style="display: block; margin-bottom: 8px;">
                  <span style="
                  top: -16px;
                  right: 8px;
                  left: 8px;
                  margin: auto -30px;
                  position: absolute;
                  z-index: 1;
                  transform: scale(0.7);
                  ">
                    <span style="
                      color: ${button.backgroundColor};
                      background-color: ${button.fontColor};
                      border: 2px solid ${button.backgroundColor};
                      display: inline-block;
                      border-radius: 50px;
                      -webkit-box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
                      box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
                      padding: 4px 8px 3px;
                      font-size: 8px;
                      letter-spacing: 2px;
                      align-self: center;
                    ">
                      ${button.labelText}
                    </span>
                    <span style="
                      display: block;
                      content: '';
                      position: absolute;
                      background-color: ${button.fontColor};
                      height: 10px;
                      width: 10px;
                      right: 0;
                      left: 0;
                      margin: auto;
                      bottom: -4px;
                      border-bottom: solid 1px ${button.backgroundColor};
                      border-left: solid 1px ${button.backgroundColor};
                      transform:rotate(-45deg);
                      z-index: 5;
                    ">
                    </span>
                  </span>
                </span>`
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
.tox.tox-tinymce-inline {
  z-index: 99 !important
}

.tox.tox-tinymce.tox-tinymce-inline.tox-tinymce--toolbar-sticky-off {
  top: 30% !important;
  left: 5% !important;
}

</style>
